var map = {
	"./azw-ic.svg": "6bac",
	"./azw3-ic.svg": "f399",
	"./epub-ic.svg": "7f95",
	"./mobi-ic.svg": "f3e9",
	"./mp4-ic.svg": "0e0c",
	"./pdf-ic.svg": "c25a",
	"./png-ic.svg": "2e6f",
	"./txt-ic.svg": "e07a",
	"./viwoods-ic.svg": "fa2e",
	"./zip-ic.svg": "eaa9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1221";